import React, { useState, useContext, useEffect } from 'react';
import './LookSection.css';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const LookSection = () => {
  const { t } = useContext(AppContext);

  const LOOKS = [
    { id: 'casual', title: t.lookCasual, image: 'images/L1.jpg', desc: t.lookCasualDesc },
    { id: 'office', title: t.lookOffice, image: 'images/L2.jpg', desc: t.lookOfficeDesc },
    { id: 'modern', title: t.lookModern, image: 'images/L3.jpg', desc: t.lookModernDesc },
    { id: 'classic', title: t.lookClassic, image: 'images/L4.jpg', desc: t.lookClassicDesc },
    { id: 'party', title: t.lookParty, image: 'images/L5.jpg', desc: t.lookPartyDesc },
    { id: 'evening', title: t.lookEvening, image: 'images/L6.jpg', desc: t.lookEveningDesc }
  ];

  const [activeIndex, setActiveIndex] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % LOOKS.length);
    }, 3500);

    return () => clearInterval(timer);
  }, [LOOKS.length]);

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % LOOKS.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + LOOKS.length) % LOOKS.length);
  };

  const handleCardClick = (index) => {
    setActiveIndex(index);
    navigate(`/products?look=${LOOKS[index].id}`);
  };

  return (
    <section className="look-carousel-section">
      <div className="section-header reveal">
        <h2 className="section-title">{t.lookTitle} <span className="title-italic">{t.lookTitleItalic}</span></h2>
        <div className="title-ornament">
          <span></span>
          <span className="ornament-diamond">◆</span>
          <span></span>
        </div>
      </div>

      <div className="carousel-wrapper">
        <button className="carousel-nav prev-btn" onClick={handlePrev} aria-label="Previous look">
          <span>&lsaquo;</span>
        </button>

        <div className="stacked-cards-container">
          {LOOKS.map((look, index) => {
            let diff = index - activeIndex;
            if (diff < -LOOKS.length / 2) diff += LOOKS.length;
            if (diff > LOOKS.length / 2) diff -= LOOKS.length;

            const isActive = index === activeIndex;
            const absDiff = Math.abs(diff);
            if (absDiff > 2) return null;

            const transform = `translateX(${diff * 155}px) scale(${1 - absDiff * 0.12}) rotateY(${diff * -16}deg)`;
            const zIndex = 10 - absDiff;
            const opacity = 1 - absDiff * 0.25;

            return (
              <div
                key={look.id}
                className={`look-card ${isActive ? 'active' : ''}`}
                style={{ transform, zIndex, opacity }}
                onClick={() => handleCardClick(index)}
              >
                <div className="look-card-inner">
                  <div className="look-image" style={{ backgroundImage: `url(${look.image})` }} />
                  <div className="look-info">
                    <h4>{look.title}</h4>
                    {isActive && <p className="look-desc">{look.desc}</p>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button className="carousel-nav next-btn" onClick={handleNext} aria-label="Next look">
          <span>&rsaquo;</span>
        </button>
      </div>

      <div className="active-look-details">
        <h3>{LOOKS[activeIndex].title}</h3>
        <p>{LOOKS[activeIndex].desc}</p>
        <button className="btn-shop-look" onClick={() => navigate('/products')}>
          {t.shopTheLook}
        </button>
      </div>
    </section>
  );
};

export default LookSection;
